import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
// Material UI
import { Grid, LinearProgress, Typography } from '@mui/material';
// Components
import { Button, Pill, Tooltip, Select } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';

// Actions
import { catalogLoad } from "Redux/actions";
import { changeStatusDriver, setOpenChangeStatus, resetDriverChangeStatusState } from "./redux/slices";
import { getProgressLineClassColor } from "../../../../../maintenance/.globals/helpers";
import { Table } from "Components/uiControls";

import './styles.scss';

const ChangeStatus = (props) => {
    // Intl
    const { messages } = useIntl();

    //props
    const { callback } = props;

    // Hooks
    const dispatch = useDispatch();

    // State local
    const loading = useSelector(state => state.driverRedux.loading);
    let loadingStatus = useSelector(state => state.driverChangeStatusSliceRedux.loadingChangeStatusDriver);
    const open = useSelector(state => state.driverChangeStatusSliceRedux.openChangeStatus);
    const response = useSelector(state => state.driverChangeStatusSliceRedux.changeStatusResponse);
    const errorChangeStatusDriver = useSelector(state => state.driverChangeStatusSliceRedux.errorChangeStatusDriver);
    let items = useSelector(state => state.driverChangeStatusSliceRedux.items);
    const tableRef = useRef();

    const [nextStep, setNextStep] = useState(0)
    const [statusDriver, setStatusDriver] = useState(0)
    const [errorNoSelected, setErrorNoSelected] = useState(false)
    const [currentItem, setCurrentItem] = useState(null)
    const [currentItems, setCurrentItems] = useState(items)


    const columns = getColumns(messages, '', setCurrentItem);
    const statusOptionDriver = [
        { value: 1, name: messages['active'] },
        { value: 0, name: messages['inactive'] }
    ]

    useEffect(() => {
        if (currentItem) {
            setCurrentItems(currentItems.filter(item => item.driverId !== currentItem.driverId));
            if (currentItems.length === 1) {
                handleClose();
            }
        }
    }, [currentItem]);

    useEffect(() => {
        if (errorChangeStatusDriver) {
            let message = messages['errorMessage'];
            if (errorChangeStatusDriver?.error?.includes("work orders")) {
                message = messages['settingsDriver_workOrderError'];
            }
            NotificationManager.error(
                message,
                messages['error'],
                3000
            );
            dispatch(resetDriverChangeStatusState({ errorChangeStatusDriver: null }));
        }
    }, [errorChangeStatusDriver])

    useEffect(() => {
        if (response && open) {
            if (response?.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                NotificationManager.success(
                    messages['settingsDriver_successChangeStatus'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                if (callback) callback();
                handleClose();

                dispatch(catalogLoad(["drivers"], true))
            }
            dispatch(resetDriverChangeStatusState({ changeStatusResponse: null }));

        }
    }, [response, open]);

    const handleClose = useCallback(() => {
        dispatch(setOpenChangeStatus({
            items: [],
            open: false
        }));
        dispatch(resetDriverChangeStatusState({
            openChangeStatus: false,
            selectedItems: [],
            loading: false,
            loadingStatus: false
        }));
    });

    let barColor = getProgressLineClassColor('Scheduled', 50);

    return (
        <Fragment>
            <Modal
                title={messages["settingsDriver_changeStatus"]}
                open={open}
                size="small"
                handleClose={handleClose}
                position="right"
                loading={loading || loadingStatus}
                className="overflow-hidden"
            >

                <ModalBody style={{ padding: 25 }}>
                    <Tooltip placement="top" title={`(${nextStep ? 100 : 50}%)`}>
                        <div style={{ padding: '5px 10px 10px 0px' }}>
                            <LinearProgress variant="determinate" className={barColor} value={nextStep ? 100 : 50} />
                        </div>
                    </Tooltip>
                    {
                        nextStep === 0 && (
                            <>
                                <div style={{ display: 'table' }}>
                                    <Table
                                        ref={tableRef}
                                        data={currentItems || []}
                                        order={'asc'}
                                        loading={loadingStatus}
                                        keyColumn="name"
                                        topheight={180}
                                        columns={columns}
                                        valuesPerPage={[]}
                                        fixHeader
                                        className="table-change-status"
                                        hideDragable
                                        disableItemSelection
                                        hidePerPage
                                        hideTotal
                                        hideAllInPagination
                                        selectAllRows={items.length}
                                        messageNoData={messages['reportsMainST_withoutSchedules']}
                                    />
                                </div>
                            </>
                        )
                    }
                    {
                        nextStep === 1 && (
                            <>
                                <Grid item sm={12}>
                                    <Select
                                        id="status"
                                        label={messages['settingsDriver_status']}
                                        placeholder={messages['settingsDriver_status']}
                                        valueField="value"
                                        textField="name"
                                        options={statusOptionDriver}
                                        value={statusDriver}
                                        onChange={(data) => {
                                            setStatusDriver(data);
                                            setErrorNoSelected(false)
                                        }}
                                        isClearable
                                        required
                                        requiredMessage={messages['required_field']}
                                    />
                                </Grid>
                                {errorNoSelected && <small className="select-error text-danger">{messages["reportsMainRT_itemsError"]}</small>}
                            </>
                        )
                    }
                </ModalBody>
                <ModalFooter>
                    {
                        nextStep === 0 && (
                            <>
                                <Button
                                    onClick={handleClose}
                                    className="btn-cancel"
                                >
                                    {messages["cancel"]}
                                </Button>
                                <Button
                                    id={'btn-change-status'}
                                    type="button"
                                    disabled={loadingStatus}
                                    onClick={(e) => {
                                        setNextStep(1);
                                    }}
                                    className="btn-black"
                                >
                                    {messages["next"]}
                                </Button>
                            </>
                        )
                    }
                    {
                        nextStep === 1 && (
                            <>
                                <Button
                                    onClick={handleClose}
                                    className="btn-cancel"
                                >
                                    {messages["cancel"]}
                                </Button>
                                <Button
                                    id={'btn-change-status'}
                                    type="button"
                                    disabled={loadingStatus}
                                    onClick={(e) => {
                                        setNextStep(0);
                                    }}
                                    className="btn-gray"
                                >
                                    {messages["back"]}
                                </Button>
                                <Button
                                    id={'btn-change-status'}
                                    type="button"
                                    disabled={loadingStatus}
                                    onClick={(e) => {
                                        if (e) e.preventDefault();
                                        if (statusDriver) {
                                            const filterItems = currentItems.filter(item => item.status !== (statusDriver.value));
                                            if (filterItems.length)
                                                dispatch(changeStatusDriver({ items: filterItems, status: statusDriver.value }));
                                            else {
                                                handleClose();
                                                NotificationManager.success(
                                                    messages['settingsDriver_successChangeStatus'],
                                                    messages['success'],
                                                    3000,
                                                    null,
                                                    null,
                                                    'success',
                                                );
                                            }
                                        }
                                        else
                                            setErrorNoSelected(true)
                                    }}
                                    className="btn-black"
                                >
                                    {messages["settingsDriver_change"]}
                                </Button>
                            </>
                        )
                    }
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}


const getColumns = (messages, title, setCurrentItem) => {
    return [
        {
            key: 'name',
            show: true,
            sort: true,
            title: title,
            sortValue: (item) => item?.driverId,
            export: false,
            render: (item) => {
                return (
                    <div style={{ width: '345px' }}>
                        <Grid item xs zeroMinWidth style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8 }}>
                            <Typography noWrap className={'component-single-inactive'}>
                                <span>{item?.name || ""}</span>
                            </Typography>
                        </Grid>

                        <Grid item xs style={{ marginTop: 10 }}>
                            <Pill
                                colorField="color"
                                textField="label"
                                item={{
                                    label: item.status ? messages['active'] : messages['inactive'],
                                    color: item.status ? '#66bb6a' : '#bdbdbd'
                                }}
                                style={{ border: '0', width: '150px' }}
                            />
                        </Grid>
                    </div>
                )
            }
        },
        {
            key: 'icon',
            show: true,
            sort: false,
            title: title,
            export: false,
            render: (item) => {
                return (
                    <div style={{ width: '45px' }}>
                        <Grid item xs zeroMinWidth>
                            <div>
                                <Grid item xs>
                                    <Button
                                        type="icon"
                                        icon="remove_circle"
                                        className="btn-cancel"
                                        placement="bottom"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentItem(item);
                                        }}
                                    />
                                </Grid>
                            </div>
                        </Grid>
                    </div>
                )
            }
        }
    ];
}

export default ChangeStatus;
